var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("Card", { staticClass: "dummy-page-item" }, [
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-md-8 push-md-4" }, [
        _c("div", { staticClass: "page-summary-container" }, [
          _c("div", { staticClass: "page-summary" }, [
            _c("div", { staticClass: "block-1" }),
            _vm._v(" "),
            _c("div", { staticClass: "block-2" }),
            _vm._v(" "),
            _c("div", { staticClass: "block-3" })
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-md-4 pull-md-8" }, [
        _c("div", { staticClass: "card-top-info" }, [
          _c("div", { staticClass: "block-1" }),
          _vm._v(" "),
          _c("div", { staticClass: "block-2" })
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "card-bottom-info" }, [
          _c("div", { staticClass: "block-1" }),
          _vm._v(" "),
          _c("div", { staticClass: "block-2" }),
          _vm._v(" "),
          _c("div", { staticClass: "block-3" })
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-48da220a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-48da220a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/DummyPageItem.vue
// module id = 3veI
// module chunks = 1